@let supervisorName = supervisorName$ | async;
@let supervisorTooltip = supervisorName ? ('term.supervisor' | translate) + ': ' + supervisorName : '';

<div class="user">

  @if (showAvatar) {
    <span class="user__avatar"
      [class.user__avatar_supervised]="supervisorName"
      [matTooltip]="supervisorTooltip">
      {{ initials$ | async }}
    </span>
  } @else if (supervisorName) {
    <mat-icon class="user__supervisor-icon text-accent" [matTooltip]="supervisorTooltip">
      supervisor_account
    </mat-icon>
  }

  @if (showName) {
    <span class="user__name">{{ userName$ | async }}</span>
  }

</div>
